export const STORAGE_KEY = 'novala.cleanupHistory';
export const ARCHIVED_KEY = 'novala.archivedAccounts';
export const MERGED_KEY = 'novala.mergedPairs';
export const APPROVED_CAT_KEY = 'novala.approvedCategorize';
export const MOCK_UNDONE_KEY = 'novala.undoneMockHistoryIds';